export default __webpack_public_path__ + "static/media/img10.0c522c82.PNG";